import { InfoDialogData } from '../shared/info-dialog/info-dialog.interface';

export const ASSET_FLAGS_LEGEND: InfoDialogData = {
  title: 'Asset Flags',

  paragraphs: [
    'Flags provide a quick overview of important Asset information.',
    'Only flags that apply to an Asset are displayed in the Assets list.'
  ],

  items: [
    {
      id: 'visible-on-mobile',
      icon: 'visibility',
      iconClass: 'info-icon-green',
      label: 'Visible on Mobile App',
      description:
        'Indicates that the Asset is configured to be visible in the Mobile App.'
    },
    {
      id: 'movable',
      icon: 'directions_car',
      iconClass: 'info-icon-blue',
      label: 'Movable Asset',
      description: 'Indicates that the Asset is classified as movable.'
    },
    {
      id: 'safety-critical',
      icon: 'warning',
      iconClass: 'info-icon-red',
      label: 'Safety Critical',
      description:
        'Indicates that the Asset has been identified as safety critical.'
    },
    {
      id: 'maintenance-scheduled',
      icon: 'handyman',
      iconClass: 'info-icon-black',
      label: 'Maintenance Scheduled',
      description:
        'The Asset has an incomplete Maintenance Record that is not due soon.'
    },
    {
      id: 'maintenance-due-soon',
      icon: 'handyman',
      iconClass: 'info-icon-orange',
      label: 'Maintenance Due Soon',
      description:
        'The Asset has an incomplete Maintenance Record approaching its due date.'
    },
    {
      id: 'maintenance-overdue',
      icon: 'handyman',
      iconClass: 'info-icon-red info-icon-flicker',
      label: 'Maintenance Due Today / Overdue',
      description:
        'The Asset has an incomplete Maintenance Record that is due today or has passed its due date.'
    }
  ],

  alert: {
    type: 'info',
    icon: 'info',
    message:
      'Maintenance indicators are based on incomplete Maintenance Records. ' +
      'If an Asset has multiple incomplete Maintenance Records, the most urgent status is displayed.'
  }
};

export const ASSET_BASIC_FLAGS_LEGEND: InfoDialogData = {
  title: ASSET_FLAGS_LEGEND.title,

  paragraphs: ASSET_FLAGS_LEGEND.paragraphs,

  items: ASSET_FLAGS_LEGEND.items.filter((item) =>
    ['visible-on-mobile', 'movable', 'safety-critical'].includes(item.id)
  )
};
